<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="card">
          <div class="card-header">
            Pastas
            <span class="pull-right">{{ $store.state.folders.items.length }} / {{ $store.state.folders.total }} items</span>
          </div>
          <div class="card-body">
            <b-row>
              <b-col v-if="canAddFolder" md="auto" class="pr-1">
                <b-button variant="primary" @click="openModal()">
                  <i class="fa fa-plus"></i> Adicionar
                </b-button>
              </b-col>
              <b-col class="pl-1">
                <b-form-input v-model="search" placeholder="Busca..." class="mb-2" debounce="500"></b-form-input>
              </b-col>
              <b-col sm="auto">
                <span class="badge badge-success" @click="filter='active'">Ativo ({{ $store.state.folders.active }})</span>
                <span class="badge badge-danger" @click="filter='inactive'" style="margin-left: 5px;">Inativo ({{ $store.state.folders.inactive }})</span>
                <a href="#" style="margin-left: 5px;" @click.prevent="filter='all'">Todos</a>
              </b-col>
            </b-row>
            <b-table class="table" :items="$store.state.folders.items" responsive="sm" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" no-local-sorting>
              <template v-slot:cell(location)="row">
                <div>
                  <div class="text-primary d-flex align-items-center p-3 accordion-toggle" data-toggle="collapse" role="button" aria-expanded="true" aria-controls="collapseExample" @click="row.toggleDetails">
                    <i class="fa fa-chevron-up" :class="row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down'" style="cursor: pointer"></i>
                    <i class="fa fa-folder fa-3x p-3 fa-chevron-up fa-chevron-down" style="cursor: pointer"></i>
                    <div>
                      <div class="text-value-sm" title="Localização">
                        <span v-if="row.item.active" class="badge badge-warning" style="font-size: 1.1rem">{{ row.item.location }}-{{ row.item.location_letter }}</span>
                        <small v-else class="badge badge-light text-muted">{{ row.item.slug }}</small>
                      </div>
                      <div>
                        <span class="badge badge-info" style="font-size: 12px">{{ row.item.total_contracts }} contrato</span>
                      </div>
                      <div>
                        <span class="badge badge-success" style="font-size: 12px">{{ row.item.total_docs }} documento</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(created)="data">
                {{ formatDate(data.item.created) }}
              </template>
              <template v-slot:cell(actions)="data">
                <div>
                  <span v-if="data.item.active" class="badge badge-success">Ativo</span>
                  <span v-else class="badge badge-danger">Inativo</span>
                  <span class="span-is-link span-color-link float-right">
                    <i v-if="canEditFolder" class="fa fa-pencil-square-o" @click="editItem(data.item)"></i>
                    <i v-if="canDeleteFolder" class="fa fa-trash trash-color ml-3" @click="deleteItem(data.item, 'folders')"></i>
                  </span>
                </div>
              </template>
              <template v-slot:row-details="row">
                <div class="card" style="border:0">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <div class="card">
                          <div class="card-header">
                            Contratos
                          </div>
                          <ul class="list-group list-group-flush" v-for="contract in row.item.contracts" :key="contract.id">
                            <li class="list-group-item">
                              <router-link :to="'/contracts/' + contract.pk">{{ contract.title }}</router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="card">
                          <div class="card-header">
                            Documentos
                            <!-- Permissão para criar -->
                            <span class="badge badge-success badge-pill" style="border-radius:0" @click="openDocumentModal(row.item.pk)">
                              <a href="#ModalFolderDocumentAdd" class="fdAdd" style="text-decoration: none;" role="button" data-toggle="modal" data-pk="1">
                                <i class="fa fa-plus-square" style="color:white" aria-hidden="true"></i> <span style="color:white">Adicionar</span>
                              </a>
                            </span>
                          </div>
                          <div class="card-body">
                            <!-- Filtro manual para mostrar somente os documentos ativos -->
                            <ul class="list-group list-group-flush">
                              <li class="list-group-item" v-for="document in row.item.documents" :key="document.pk">
                                <div class="row">
                                  <div class="col-12 col-lg-6">
                                    <div class="card">
                                      <div class="card-body p-0 d-flex align-items-center">
                                        <i class="fa fa-file-text-o bg-primary p-5 font-2xl mr-3"></i>
                                        <div>
                                          <div class="text-value-sm text-primary">
                                            {{ document.quantity_original }}
                                            <span class="text-muted text-uppercase font-weight-bold small" style="font-size:60%">Original</span>
                                          </div>
                                          <div class="text-value-sm text-primary">
                                            {{ document.quantity_copy_simples }}
                                            <span class="text-muted text-uppercase font-weight-bold small" style="font-size:60%">Simples</span>
                                          </div>
                                          <div class="text-value-sm text-primary">
                                            {{ document.quantity_copy_authenticated }}
                                            <span class="text-muted text-uppercase font-weight-bold small" style="font-size:60%">Autenticada</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-lg-4">
                                    <div class="row">
                                      <div class="col">
                                        <span class="badge badge-warning badge-pill" style="border-radius:0">{{ document.type_document.title }}</span>
                                      </div>
                                      <div class="col">
                                        <span class="pull-right">
                                          {{ formatDate(document.created) }}
                                        </span>
                                      </div>
                                    </div>
                                    {{ document.description }}
                                  </div>
                                  <div class="col-12 col-lg-2">
                                    <div class="pull-right">
                                      <!-- Permissão para editar -->
                                      <span class="span-is-link span-color-link float-right">
                                        <i v-if="canEditFolder" class="fa fa-pencil-square-o" @click="editDocument(document)" title="Editar"></i>
                                        <i v-if="canDeleteFolder" class="fa fa-trash trash-color ml-3" @click="deleteItem(document, 'documents')" title="Apagar"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </b-table>

            <div style="text-align: right;">
              <b-pagination
                :total-rows="$store.state.folders.total"
                :per-page="$store.state.folders.perPage"
                v-model="currentPage"
                style="display: inline-flex;"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-modal :visible="isVisible" :title="editingItem.pk ? 'Editar' : 'Adicionar'" @ok.prevent="passes(sendItem)" @hidden="clearModal" cancel-title="Cancelar" ok-title="Salvar">
        <generic-form :fields="fields" :editing="editingItem"></generic-form>
      </b-modal>
    </ValidationObserver>
    <ValidationObserver ref="document_observer" v-slot="{ passes }">
      <b-modal :visible="isDocumentVisible" :title="editingDocument.pk ? 'Editar' : 'Adicionar'" @ok.prevent="passes(sendDocument)" @hidden="clearModal" cancel-title="Cancelar" ok-title="Salvar">
        <generic-form :fields="documentFields" :editing="editingDocument"></generic-form>
      </b-modal>
    </ValidationObserver>
  </div>
</template>
<script>
import CRMGeneric from '../crm/CRMGeneric';
import GenericForm from '../../components/GenericForm';
import moment from 'moment';
import axios from 'axios';
import Vue from 'vue';

export default {
  components: {
    'crm-generic': CRMGeneric,
    GenericForm,
  },
  data() {
    return {
      currentPage: 1,
      tableFields: [{
        label: 'Localização',
        key: 'location',
        sortable: true,
      }, {
        label: 'Cliente',
        key: 'customer.social_name',
        sortable: true,
      }, {
        label: 'Descrição',
        key: 'description',
      }, {
        label: 'Criado em',
        key: 'created',
      }, {
        label: 'Ações',
        key: 'actions',
      }],
      documents: {},
      editingItem: {
        description: '',
        // location: '',
        active: true
      },
      editingDocument: {
        type_document_pk: null,
      },
      contracts: [],
      documentTypes: [],
      isDocumentVisible: false,
      isVisible: false,
      search: '',
      filter: 'active',
      lastLoadedContracts: 0,
      sortBy: 'location',
      sortDesc: false,
    }
  },
  mounted() {
    this.currentPage = 1;

    this.$store.dispatch('folders/loadItems', {
      search: '',
      filter: this.filter,
      page: this.currentPage,
      order_by: this.sortBy,
      is_desc: this.sortDesc,
    });
    this.$store.dispatch('customers/loadItems');

    axios.get('/folder/type_document')
      .then(res => {
        this.documentTypes = res.data.data.map(t => ({
          value: t.pk,
          text: t.title,
        }));
      });
  },
  computed: {
    canAddFolder() {
      return this.$store.state.auth.user.permission_codes.includes('add_folder');
    },
    canEditFolder() {
      return this.$store.state.auth.user.permission_codes.includes('change_folder');
    },
    canDeleteFolder() {
      return this.$store.state.auth.user.permission_codes.includes('delete_folder');
    },
    fields() {
      return [{
          text: 'Ativo',
          name: 'active',
          type: this.editingItem.pk ? 'checkbox' : 'hidden',
        },
        {
          text: 'Cliente',
          name: 'customer_pk',
          type: 'select2',
          selectOptions: this.$store.state.customers.items,
          label: 'social_name',
          rules: 'required',
        },
        {
          text: 'Contrato',
          name: 'contracts_pks',
          checkboxOptions: this.contracts,
          type: 'checkbox_group',
          text_field: 'title',
          value_field: 'pk',
        }, {
          text: 'Descrição',
          name: 'description',
          rules: 'required',
          type: 'textarea',
        // }, {
        //   text: 'Localização',
        //   name: 'location',
        //   rules: 'required',
        },
      ]
    },
    documentFields() {
      return [{
        text: 'Descrição',
        name: 'description',
        rules: 'required',
        type: 'textarea',
      }, {
        text: 'Qte original',
        name: 'quantity_original',
        type: 'number',
        rules: 'required',
      }, {
        text: 'Qte cópia simples',
        name: 'quantity_copy_simples',
        type: 'number',
        rules: 'required',
      }, {
        text: 'Qte cópia autenticada',
        name: 'quantity_copy_authenticated',
        type: 'number',
        rules: 'required',
      }, {
        text: 'Tipo de documento',
        name: 'type_document_pk',
        options: this.documentTypes,
        rules: 'required',
      }, ];
    }
  },
  watch: {
    editingItem: {
      deep: true,
      handler(newVal) {
        if (!newVal.customer_pk) {
          return;
        }

        if (this.lastLoadedContracts == newVal.customer_pk) {
          return;
        }

        this.lastLoadedContracts = newVal.customer_pk;

        axios.get('/contract/?customer_pk=' + newVal.customer_pk)
          .then(res => {
            this.contracts = res.data.data;
            this.$forceUpdate();
          });
      }
    },
    currentPage(page) {
      this.$store.dispatch('folders/loadItems', {
        search: this.search,
        filter: this.filter,
        page: page,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      });
    },
    search(newVal) {
      if (newVal.length < 3 && newVal.length != 0) {
        return;
      }
      
      this.$store.dispatch('folders/loadItems', {
        search: newVal,
        filter: this.filter,
        page: 1,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      });
    },
    filter(filter) {
      this.$store.dispatch('folders/loadItems', {
        search: this.search,
        filter: filter,
        page: this.currentPage,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      });
    },
    sortBy(newVal) {
      this.$store.dispatch('folders/loadItems', {
        search: this.search,
        filter: this.filter,
        page: this.currentPage,
        order_by: newVal,
        is_desc: this.sortDesc,
      });
    },
    sortDesc(newVal) {
      this.$store.dispatch('folders/loadItems', {
        search: this.search,
        filter: this.filter,
        page: this.currentPage,
        order_by: this.sortBy,
        is_desc: newVal,
      });
    }
  },
  methods: {
    formatDate(_date) {
      return moment(_date).format('DD/MM/YY');
    },
    async sendItem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      if (!this.editingItem.pk) {
        // Aqui está adicionando, logo no axios seria um post
        this.$store.dispatch('folders/addItem', {
          ...this.editingItem,
        });
      } else {
        // Aqui editando, logo um put
        this.$store.dispatch('folders/editItem', {
          ...this.editingItem,
        });
      }

      this.clearModal();
    },
    async sendDocument() {
      const isValid = await this.$refs.document_observer.validate();
      if (!isValid) {
        return
      }

      if (!this.editingDocument.pk) {
        this.$store.dispatch('folders/addDocument', this.editingDocument)
          .then(() => {
            this.clearModal();
          });
      } else {
        this.$store.dispatch('folders/editDocument', this.editingDocument)
          .then(() => {
            this.clearModal();
          });
      }
    },
    editItem(item) {
      this.$emit('open-modal', item);

      this.isVisible = true;

      this.editingItem = { ...item };
    },
    deleteItem(item, namespace) {
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          if (namespace == 'folders') {
            this.$store.dispatch('folders/deleteItem', item);
            return;
          }

          this.$store.dispatch('folders/deleteDocument', item);
        }
      });
    },
    editDocument(item) {
      this.isDocumentVisible = true;

      this.editingDocument = { ...item };
    },
    clearModal() {
      this.editingItem = {
        active: true
      };
      this.editingDocument = {
        type_document_pk: null,
      };
      this.contracts = [];

      this.isVisible = false;
      this.isDocumentVisible = false;
    },
    openModal() {
      this.isVisible = true;
    },
    openDocumentModal(folderId) {
      this.editingDocument.folder_pk = folderId;
      this.isDocumentVisible = true;
    },
  }
}

</script>
